import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PrimeReactProvider } from "primereact/api";
import { Amplify } from "aws-amplify";
import RouterApp from "./router/RouterApp";
import reportWebVitals from "./reportWebVitals";
import awsExports from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";
import "primereact/resources/themes/lara-light-green/theme.css";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "/node_modules/primeflex/primeflex.css";
// import "/assets/css/custom-auth.css";

import { store } from "./store";
import CustomAuthenticator from "./CustomAuthenticator";

Amplify.configure(awsExports);

console.log(process.env["REACT_APP_API"]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PrimeReactProvider>
        <CustomAuthenticator>
          <RouterApp />
        </CustomAuthenticator>
      </PrimeReactProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
